const portions = [
  {
    id: 1,
    name: "Milimeters",
    subName: "[mm]",
    disp: "MM",
    ele: "mm",
    
  },
  {
    id: 2,
    name: "Centimeters",
    subName: "[cm]",
    disp: "CM",
    ele: "cm"
  },
  {
    id: 3,
    name: "Meters",
    subName: "[m]",
    disp: "M",
    ele: "m"
  },
  {
    id: 4,
    name: "Inches",
    subName: "[in]",
    disp: "IN",
    ele: "in"
  },
]

export default portions;